import {
    GET_LIST_CUSTOMER_COMPLAINT,
    GET_SPECIFIC_CUSTOMER_COMPLAINT,
    UPDATE_CUSTOMER_COMPLAINT,
    REMOVE_CUSTOMER_COMPLAINT
} from '../actions/types';

/**
 * initial state cho module Customer Complaints
 */
const INIT_STATE = {
    customerComplaintList: [],      // danh sách phản ánh theo customer
    currentCustomerComplaint: null, // record chi tiết
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 50
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        /** 
         * Lấy danh sách phản ánh khách hàng 
         */
        case GET_LIST_CUSTOMER_COMPLAINT: {
            return {
                ...state,
                customerComplaintList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page || 1),
                    total: parseInt(action.payload.total || 0),
                    perPage: parseInt(action.payload.per_page || 50),
                }
            };
        }

        /** 
         * Lấy chi tiết 1 phản ánh 
         */
        case GET_SPECIFIC_CUSTOMER_COMPLAINT: {
            return {
                ...state,
                currentCustomerComplaint: action.payload
            };
        }

        /** 
         * Cập nhật phản ánh
         */
        case UPDATE_CUSTOMER_COMPLAINT: {
            const updatedList = state.customerComplaintList.map(item =>
                item.id === action.payload.id ? action.payload : item
            );

            return {
                ...state,
                customerComplaintList: updatedList,
                currentCustomerComplaint: action.payload
            };
        }

        /** 
         * Xoá một hoặc nhiều phản ánh khách hàng 
         */
        case REMOVE_CUSTOMER_COMPLAINT: {
            const filteredList = state.customerComplaintList.filter(
                item => !action.payload.includes(item.id)
            );

            return {
                ...state,
                customerComplaintList: filteredList,
                pagination: {
                    ...state.pagination,
                    total: state.pagination.total - action.payload.length
                }
            };
        }

        default:
            return { ...state };
    }
};
